"use client";

import { usePathname } from "next/navigation";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Theme } from "@mui/material/styles";
import {
  FaDiscord,
  FaPinterest,
  FaInstagram,
  FaLinkedin,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { MdMail } from "react-icons/md";
import dayjs from "dayjs";

import RequestFeatureButton from "./FeatureRequestButton";

const Footer = () => {
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up("lg"));
  const pathname = usePathname() as string;

  if (
    (pathname === "/subscribe" && !isDesktop) ||
    (pathname.startsWith("/idea") && !isDesktop)
  )
    return null;

  return (
    <footer className="tw:w-full tw:flex tw:flex-col tw:items-center tw:justify-between tw:gap-2 tw:fixed tw:bottom-0 tw:right-0 tw:ml-1.5 tw:py-2 tw:px-8 tw:bg-white tw:text-[0.8rem] tw:text-[#1E222A] tw:z-[100] tw:shadow-[0_-2px_0_#dee4eb] tw:lg:flex-row tw:lg:w-[calc(100vw-340px)] tw:lg:gap-0 tw:lg:py-4 tw:lg:shadow-none">
      <div className="tw:flex tw:items-center tw:gap-4">
        <p className="tw:text-xxs tw:lg:text-xs">
          &copy; Idyllic {dayjs().year()}
        </p>
        <a
          href="https://idyllic.app/privacy-policy"
          target="_blank"
          rel="noreferrer"
          className="tw:text-xxs tw:text-[#1E222A] tw:no-underline tw:lg:text-[0.8rem] tw:hover:text-primary-red"
        >
          Privacy Policy
        </a>
        <RequestFeatureButton />
      </div>
      <div className="tw:flex tw:items-center tw:gap-4">
        <a
          href="mailto:hello@idyllic.app"
          target="_blank"
          rel="noreferrer"
          className="tw:grid tw:place-items-center tw:text-base tw:text-[#1E222A] tw:no-underline tw:hover:text-primary-red tw:lg:text-2xl"
          aria-label="View Idyllic's LinkedIn profile"
        >
          <MdMail />
        </a>
        <a
          href="https://discord.gg/unmynGrMTf"
          target="_blank"
          rel="noreferrer"
          className="tw:grid tw:place-items-center tw:text-base tw:text-[#1E222A] tw:no-underline tw:hover:text-primary-red tw:lg:text-2xl"
          aria-label="Go to the Idyllic Discord channel"
        >
          <FaDiscord />
        </a>
        <a
          href="https://twitter.com/Idyllicapp"
          target="_blank"
          rel="noreferrer"
          className="tw:grid tw:place-items-center tw:text-base tw:text-[#1E222A] tw:no-underline tw:hover:text-primary-red tw:lg:text-2xl"
          aria-label="View Idyllic's Twitter profile"
        >
          <FaXTwitter />
        </a>
        <a
          href="https://www.pinterest.com/idyllicapp/"
          target="_blank"
          rel="noreferrer"
          className="tw:grid tw:place-items-center tw:text-base tw:text-[#1E222A] tw:no-underline tw:hover:text-primary-red tw:lg:text-2xl"
          aria-label="View Idyllic's Pinterest profile"
        >
          <FaPinterest />
        </a>
        <a
          href="https://www.instagram.com/idyllic.app/"
          target="_blank"
          rel="noreferrer"
          className="tw:grid tw:place-items-center tw:text-base tw:text-[#1E222A] tw:no-underline tw:hover:text-primary-red tw:lg:text-2xl"
          aria-label="View Idyllic's Instagram profile"
        >
          <FaInstagram />
        </a>
        <a
          href="https://www.linkedin.com/company/idyllic-app"
          target="_blank"
          rel="noreferrer"
          className="tw:grid tw:place-items-center tw:text-base tw:text-[#1E222A] tw:no-underline tw:hover:text-primary-red tw:lg:text-2xl"
          aria-label="View Idyllic's LinkedIn profile"
        >
          <FaLinkedin />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
